// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as DriverSuspensionListTable from "../../components/suspension-list/DriverSuspensionListTable.bs.js";

function getView(driverSuspensionData) {
  return React.createElement(DriverSuspensionListTable.make, {
              tableData: driverSuspensionData
            });
}

var DriverSuspensionListViewMapper = {
  getView: getView
};

export {
  DriverSuspensionListViewMapper ,
  
}
/* react Not a pure module */
